import {
	Route,
	RouterProvider,
	createBrowserRouter,
	createRoutesFromElements,
} from 'react-router-dom';
import AppRoutes from './App.routing';

function App() {
	const router = createBrowserRouter(
		createRoutesFromElements(
			<Route path="/*" element={<AppRoutes />}></Route>,
		),
	);
	return <RouterProvider router={router}></RouterProvider>;
}

export default App;
